
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class WIPMovementDialog extends Serenity.EntityDialog<WIPMovementRow, any> {
        protected getFormKey() { return WIPMovementForm.formKey; }
        protected getIdProperty() { return WIPMovementRow.idProperty; }
        protected getLocalTextPrefix() { return WIPMovementRow.localTextPrefix; }
        protected getNameProperty() { return WIPMovementRow.nameProperty; }
        protected getService() { return WIPMovementService.baseUrl; }
        protected getDeletePermission() { return WIPMovementRow.deletePermission; }
        protected getInsertPermission() { return WIPMovementRow.insertPermission; }
        protected getUpdatePermission() { return WIPMovementRow.updatePermission; }

        protected form = new WIPMovementForm(this.idPrefix);

    }
}